import { render } from "./Home.vue?vue&type=template&id=93dced62&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=93dced62&lang=less&scoped=true"

import exportComponent from "/Users/sun/Desktop/code/antpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93dced62"]])

export default __exports__